/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedRedemptionSummaryResponse } from '../../models/paged-redemption-summary-response';

export interface GetRedemptionSummaries$Params {
  periodEnd?: string;
  periodType?: 'DAY' | 'WEEK' | 'MONTH';
  page?: number;
  size?: number;
  filter?: Array<string>;
  'Active-Tenant-Identifier'?: string;
  groupBy?: string;
}

export function getRedemptionSummaries(http: HttpClient, rootUrl: string, params?: GetRedemptionSummaries$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedRedemptionSummaryResponse>> {
  const rb = new RequestBuilder(rootUrl, getRedemptionSummaries.PATH, 'get');
  if (params) {
    rb.query('periodEnd', params.periodEnd, {});
    rb.query('periodType', params.periodType, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('filter', params.filter, {"style":"form","explode":true});
    rb.query('groupBy', params.groupBy, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedRedemptionSummaryResponse>;
    })
  );
}

getRedemptionSummaries.PATH = '/redemptionSummaries';
